export default __webpack_public_path__ + "18b98afe8daf2e7eb0cc8cdb192a2324.svg";